import styled from "styled-components";
import { GoPrimitiveDot } from "react-icons/go";
import { Container } from "../../../components/navbar/Nav.styles";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";

const Jolly = () => {
  return (
    <ContainerProd>
      <Wrapper>
        <div>
          <div className="web__content">
            <h1>
              Time to <span className="beta__life">Jolly Jolly</span>
            </h1>
            <p>
              Imagine yourself standing on the balcony of a hotel, inhaling the
              aroma of the well prepared cup of coffee. The breathtaking view of
              the beach and palm trees greets you as the golden sun rises over
              the horizon. Amazing right? <br /> <br />
              Stop imagining! Time to make it a reality. This product is to
              enable you travel on vacation. You can save 50% of the vacation
              cost with our target/locked savings within a period of time.
              Interest rate of 3.5%-5% depending on the duration of loan. Jolly
              jolly can also be used to go on pilgrimage (Mecca and Jerusalem).
            </p>
          </div>
          <img
            className="first__image"
            style={{ marginTop: "56px" }}
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_49_2_yqadxn.png"
            alt="betalife"
          />

          <h2 className="web__features">Features</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Minimum savings of 100,000 montly.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Locked savings with tenor of 3 - 12 months</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Interest rate for proof of funds is 4% per month</span>
          </BenefitItem>
          <div className="start__saving">
            <Button to="/jolly">Start Saving</Button>
          </div>
          <div style={{ marginTop: "6rem" }}>
            <img
              className="web__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636147/invest-trust/Rectangle_9123_2_sg3w7b.png"
              alt="betalife"
            />
          </div>
        </div>
        <BenefitComp>
          <div className="mobile__content">
            <h1>
              Time to <span className="beta__life">Jolly Jolly</span>
            </h1>
            <p>
              Imagine yourself standing on the balcony of a hotel, inhaling the
              aroma of the well prepared cup of coffee. The breathtaking view of
              the beach and palm trees greets you as the golden sun rises over
              the horizon. Amazing right? <br /> <br />
              Stop imagining! Time to make it a reality. This product is to
              enable you travel on vacation. You can save 50% of the vacation
              cost with our target/locked savings within a period of time.
              Interest rate of 3.5%-5% depending on the duration of loan. Jolly
              jolly can also be used to go on pilgrimage (Mecca and Jerusalem).
            </p>
          </div>
          <div>
            <img
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651642627/invest-trust/young-black-man-with-leather-case-travel-tourist-concept_1194-20109_1_eiuyfk.png"
              alt="betalife"
            />
          </div>
          <h2>Benefits</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Reduces the pressure to travel.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Disbursement of travel funds after 50% has been saved.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>To allow pilgrim rights to be observed.</span>
          </BenefitItem>
          <div style={{ marginTop: "6rem" }}>
            <img
              className="mobile__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636147/invest-trust/Rectangle_9123_2_sg3w7b.png"
              alt="betalife"
            />
          </div>
        </BenefitComp>
      </Wrapper>
    </ContainerProd>
  );
};

export default Jolly;

export const ContainerProd = styled(Container)`
  transform: translateY(-8rem);
  background-color: #dbdbf9;
`;

export const Wrapper = styled.div`
  .web__view {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 43px;
  margin-bottom: 2rem;

  img {
    max-width: 100%;
  }

  div:nth-of-type(1) {
    // border: 3px solid teal;
  }

  div:nth-of-type(1) h1 {
    font-family: "Futura";
    font-size: 3rem;
    font-weight: 200;
    margin-bottom: 1rem;
  }
  div:nth-of-type(1) p {
    margin-top: 0rem;
    font-size: 20px;
    padding-right: 2.5rem;
    // border: 3px solid red;
  }

  .beta__life {
    color: ${({ theme }) => theme.colors.secondary};
  }
  .start__saving {
    margin-top: 4rem;
  }
  .start__saving a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  .bullet__point {
    font-size: 32px;
    color: #1b20e5;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    .start__saving {
      display: flex;
      justify-content: center;
    }
    .web__content {
      display: none;
    }
    .web__view {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 3rem;
      text-align: center;
    }
    .beta__life {
      display: block;
    }
    div:nth-of-type(1) p {
      font-size: 20px;
      padding-right: 0rem;
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    grid-template-columns: 1fr;
    .first__image {
      transform: translateY(-10rem);
    }
    .web__features {
      transform: translateY(-10rem);
      margin-bottom: -8rem;
      //   border: 2px solid red;
    }
    .beta__life {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 2rem;
      text-align: center;
      line-height: 40px;
    }
    .bullet__point {
      margin-top: 0.4rem;
      font-size: 16px;
      color: #1b20e5;
    }
  }
`;

export const BenefitComp = styled.div`
 
  .mobile__content {
    display: none;
  }
  .mobile__view {
    display: inline-block;
  }
  div: nth-of-type(2);
  @media screen and (max-width: 991px) {
    grid-row-start: 1;
    grid-row-end: 3;
    .mobile__content {
      display: block;
    }
    .mobile__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  // width: 577px;

  .product__dot {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary};
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  span {
    font-size: 20px;
  }
  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    align-items: flex-start;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  span {
    font-size: 20px;
    padding-right: 2rem;
  }
`;
